'use strict';

import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import PasswordVisibility from "@stimulus-components/password-visibility";
import Alert from '@webit/corporate-design/components/alert/alert_controller'

const application = Application.start()
application.register('password-visibility', PasswordVisibility)
application.register('alert', Alert)


Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target);
};
